var render = function render(){var _vm=this,_c=_vm._self._c;return _c('custom-separator',{staticClass:"custom-separator-extended py-3",attrs:{"text":_vm.text}})
}
var staticRenderFns = []

export { render, staticRenderFns }